import { Grid } from "@material-ui/core";
import React from "react";

const CustomFlower = ({
  scale,
  right,
  top,
  scale_top_left,
  scale_top_right,
  scale_bottom_right,
  scale_bottom_left,
}) => {
  return (
    <Grid
      container
      justifyContent="space-between"
      style={{
        width: 45,
        height: 45,
        position: "absolute",
        right: right,
        top: top,
        transform: `scale(${scale})`,
      }}
    >
      <div
        style={{
          width: 20,
          height: 20,
          transform: `scale(${scale_top_right ? scale_top_right : 1})`,
          backgroundColor: "rgba(0,0,0, 0.3)",
          borderBottomRightRadius: 50,
          borderTopLeftRadius: 50,
        }}
      ></div>
      <div
        style={{
          width: 20,
          height: 20,
          transform: `scale(${scale_top_left ? scale_top_left : 1})`,

          backgroundColor: "rgba(0,0,0, 0.2)",
          borderBottomLeftRadius: 50,
          borderTopRightRadius: 50,
        }}
      ></div>
      <div
        style={{
          width: 20,
          height: 20,
          transform: `scale(${scale_bottom_right ? scale_bottom_right : 1})`,

          backgroundColor: "rgba(0,0,0, 0.3)",
          borderBottomLeftRadius: 50,
          borderTopRightRadius: 50,
        }}
      ></div>
      <div
        style={{
          width: 20,
          height: 20,
          transform: `scale(${scale_bottom_left ? scale_bottom_left : 1})`,

          backgroundColor: "rgba(0,0,0, 0.2)",
          borderBottomRightRadius: 50,
          borderTopLeftRadius: 50,
        }}
      ></div>
    </Grid>
  );
};

export default CustomFlower;
